import React, { useCallback} from "react";
import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Icon from "components/Icons/Icon";
import Alert from "components/Common/Alert";
// import conxtdOut from "apis/conxtdOut";
import { loadCompanyAssetsStart } from "services/redux/actions/serviceDesk";
import conxtdOut from "apis/conxtdOut";

const DuplicateAssets = ({ 
  selectedCount,
  selection,
  setSelection,
  selectAll, 
  setSelectAll, 
  companyId, 
  checkboxPagination,
  tableFilters,
  triggerDispatch,
 }) => {

  const darkMode = useSelector(state => state.app.darkMode)
  // const dispatch = useDispatch();

  const handleDuplicateAssets = useCallback(() => {

    if (!companyId) {
      return Alert({
        text: "No Company ID detected, cannot proceed.",
        icon: "error",
        timerProgressBar: true,
        timer: 5000,
      });
    }

    Alert({
      html: `<span class="mt-1">Are you sure you want to duplicate <span class="font-weight-bold">${selectedCount}</span> asset${selectedCount > 1 ? 's' : ''}?</span>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.value) {

        let duplicateAssets = null;

        duplicateAssets = conxtdOut.post('/company-assets-bulk/duplicate', {
          "asset_ids" : selection,
          "company_id": companyId,
          "select_all": selectAll,
          ...checkboxPagination,
        })

        duplicateAssets.then(() => {
          Alert({
            text: "Assets duplicated successfully",
            icon: "success",
            timerProgressBar: true,
            timer: 5000,
          });

          setSelection([]);
          setSelectAll(false);
          
          triggerDispatch();

        }).catch((error) => {
          console.log("error", error.message);
          Alert({
            text: "Failed to duplicate assets, please try again later.",
            icon: "error",
            timerProgressBar: true,
            timer: 5000,
          });
        })
      }
    })
  }, [companyId, selectedCount, selection, setSelection, setSelectAll, checkboxPagination, tableFilters, triggerDispatch]);

  return (
    <>
      <Button
        variant={darkMode ? 'primary' : 'light'}
        type="submit"
        className="action-button"
        id="update-fields-button"
        onClick={() => handleDuplicateAssets()}
      >
        <Icon className="fas fa-copy icons" />
        <span className="action-text">Duplicate Assets</span>
      </Button>
    </>
  );
}

export default DuplicateAssets;
